module.exports = __webpack_public_path__ + "media/assets/site_images/team/thiago-03edc51cd1b2fc34301afcb276583ffb.jpg";